import React from "react";
import Label from "./Label";
import styled from "styled-components";

const Input = styled.input`
  &[type="number"] {
    -moz-appearance: textfield;
    ::-webkit-inner-spin-button,
    ::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }
  }
`;

const TextInput = ({
  onChange,
  value = "",
  id,
  name,
  label = "",
  disabled = false,
  readOnly = false,
  placeholder = "",
  type = "text",
  iconPosition = "left",
  hasAddOn = false,
  hasIcon = false,
  numbersOnly = false,
  autoComplete = "off",
  prefix = "",
  className = "",
  maxLength,
  onBlur,
  onFocus,
  hasError = "",
  isInputGroup = false,
  ref = null,
  wrapPrefix = true,
}) => {
  const handleChange = (e) => {
    if (numbersOnly) {
      try {
        const numberValue = e.target.value.replace(/\D/g, "").length
          ? parseInt(e.target.value.replace(/\D/g, ""))
          : "";
        onChange(numberValue);
      } catch (error) {
        console.log(error);
        onChange(e.target.value);
      }
      return;
    }
    onChange(e.target.value);
  };
  return (
    <>
      {label && <Label>{label}</Label>}
      <div className="w-full">
        <div className="flex w-full">
          {prefix && (
            <div
              className={`${!wrapPrefix && "whitespace-nowrap"} inline-flex items-center px-3 rounded-l-md border border-r-0 border-primary-300 bg-primary-100 text-primary-800 sm:text-sm font-base`}
            >
              {prefix}
            </div>
          )}
          <Input
            type={type}
            name={name}
            id={id}
            ref={ref}
            value={value}
            onChange={handleChange}
            maxLength={maxLength}
            onBlur={onBlur}
            onFocus={onFocus}
            readOnly={readOnly}
            disabled={disabled}
            max={type === "date" && "9999-12-31"}
            className={`form-input ${
              hasIcon ? (iconPosition === "left" ? "pl-10" : "pr-10") : "px-3"
            } ${
              hasAddOn ? "rounded-none rounded-r-md" : "rounded-md shadow-sm"
            } ${className ? className : "block w-full text-sm"} ${
              !hasError
                ? "text-brand-500 border-primary-300 focus:border-brand-500 focus:ring-brand-500"
                : "text-red-900 border-red-500"
            }`}
            placeholder={placeholder}
            autoComplete={autoComplete}
          />
        </div>
        {hasError && !isInputGroup && (
          <span className="text-red-500 text-sm block mt-1">{hasError}</span>
        )}
      </div>
    </>
  );
};

export default TextInput;
